var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1606",
    "data-name": "Grupo 1606",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.257,
    height: 36.257,
    viewBox: "0 0 36.257 36.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7268",
    "data-name": "Trazado 7268",
    d: "M41.717,358.271a18.129,18.129,0,1,0-20.961,17.908V363.511h-4.6v-5.24h4.6v-3.994c0-4.543,2.706-7.053,6.847-7.053a27.871,27.871,0,0,1,4.058.354v4.461H29.375a2.62,2.62,0,0,0-2.954,2.831v3.4h5.028l-.8,5.24H26.421v12.668a18.133,18.133,0,0,0,15.3-17.908",
    transform: "translate(-5.46 -340.142)",
    fill: "#4676ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7269",
    "data-name": "Trazado 7269",
    d: "M59.767,382.8l.8-5.24H55.543v-3.4a2.62,2.62,0,0,1,2.954-2.831h2.286v-4.461a27.89,27.89,0,0,0-4.058-.354c-4.141,0-6.847,2.51-6.847,7.053v3.994h-4.6v5.24h4.6v12.668a18.318,18.318,0,0,0,5.665,0V382.8Z",
    transform: "translate(-34.582 -359.428)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookColor);
export default __webpack_public_path__ + "static/media/facebook_color.bab58aa7c422aacbd02f14ad1a36c51f.svg";
export { ForwardRef as ReactComponent };